module.exports = __webpack_public_path__ + "img/car.16953a6c.svg";